// import { DetailBorrowFormTrainContainer } from "../../../../containers/borrowSystem/BorrowForm/JuristicType/DetailBorrowFormTrainContainer"
import { JobPositionFormTestContainer } from "../../../containers/borrowSystem/BorrowForm/JobPositionFormTestContainer"

export function JobPositionFormTestPage() {
    return (
        <JobPositionFormTestContainer />
    )
}